import Block from '_core_ext/core/common/Block';

export default class AccountNavigation extends Block {
    init() {
        var activeControllerName = pageContext.pipelineName.toLowerCase();
        this.$el.find('.js-sidebar-' + activeControllerName).addClass('is--active');
    }
}
